import { apiRequestDev } from './apiRequest';

export const getRidingShapes = async (config, ridingId) => apiRequestDev(config, `/polls/shapes/${ridingId}`);

export const getAllRidingShapes = async (config) => apiRequestDev(config, '/polls/shapes/');

export const getPollData = async (config, pollId) => apiRequestDev(config, `/polls/data/${pollId}`);
